import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70a14c5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-checked"]
const _hoisted_2 = { class: "theme-slider__thumb" }

import {MoonIcon, SunIcon} from '@/components/icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'ThemeSlider',
  props: {
    toggleTheme: { type: Function },
    theme: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
            'theme-slider': true,
            [props.theme]: true,
        }),
    role: "switch",
    "aria-checked": props.theme === 'light' ? 'true' : 'false',
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (props.toggleTheme && props.toggleTheme(...args)))
  }, [
    _createElementVNode("div", _hoisted_2, [
      (props.theme === 'light')
        ? (_openBlock(), _createBlock(_unref(SunIcon), {
            key: 0,
            color: "black"
          }))
        : _createCommentVNode("", true),
      (props.theme === 'dark')
        ? (_openBlock(), _createBlock(_unref(MoonIcon), {
            key: 1,
            color: "black"
          }))
        : _createCommentVNode("", true)
    ])
  ], 10, _hoisted_1))
}
}

})